<template>

    <div class="nanjing">
        <ul style="list-style: none;height: 100%">
            <li style="color: #333;font-weight: 400;">Firmensitz</li>
            <li style="border-bottom: 1px solid #eee;">
                <p style="padding-top: 10%"><i class="el-icon-phone-outline"></i></p>
                <p >Telefon</p>
                <p>+86-025-85593856 85614061</p>
            </li>
            <li style="border-bottom: 1px solid #eee">
                <p style="padding-top: 10%"><i class="el-icon-printer"></i></p>
                <p >Faksimile</p>
                <p>+86-025-85502771 85592481</p>
            </li>
            <li >
                <p style="padding-top: 10%"><i class="el-icon-message"></i></p>
                <p >Postfach</p>
                <p>ifcores@hotmail.com</p>
            </li>
        </ul>
    </div>
    <div id="container">

    </div>
</template>
<script>

    export default {
        name: "MapContainer",

        data() {
            return {
                map : null,
                mouseTool : null,
                overlays : [],
                auto : null,
                placeSearch : null,
                marker:null,

            }
        },

        mounted() {
            // this.initAMap();




            this.initTdtMap()



        },
        unmounted() {
            this.map?.destroy();
        },

        methods: {


            initTdtMap() {
                let T = window.T;
                this.tdtMap = new T.Map("container");
                //设置显示地图的中心点和级别
                this.tdtMap.centerAndZoom(new T.LngLat(118.91619,32.15611), 12);
                this.label=new T.Label({
                    text: '<div  class="box" style="width:450px;\n' +
                        '        opacity: 1;border-radius: 5px;background: #004ea2 !important;height: 120px;padding: 10px;\n' +
                        '        margin-top:10px;position: relative">\n' +
                        '        <p style="content: \'\';\n' +
                        '        width: 0;\n' +
                        '        height: 0;\n' +
                        '        top: auto;\n' +
                        '        position: absolute;\n' +
                        '        left: 6%;\n' +
                        '        right: 0;\n' +
                        '        top: -10px;\n' +
                        '        margin-left: -10px;\n' +
                        '        border-bottom: 10px solid #004ea2;\n' +
                        '        border-right: 10px solid transparent;\n' +
                        '        border-left: 10px solid transparent;\n' +
                        '        box-sizing: border-box"></p>' +
                        '        <ul style="list-style: none">\n' +
                        '            <li style="float:left;width: 35%">\n' +
                        '            <li style="float:left;width: 65%">\n' +
                        '                <ul style="list-style: none">\n' +
                        '                    <li style="margin-top: 5px;font-size: 18px;color: #fff;font-family:\'Helvetica Neue\',Arial,Helvetica,sans-serif;">Nanjing Hengchuang Magnetoelectronics Co., Ltd.</li>\n' +
                        '                    <li style="width: 100%;font-size: 16px;margin-top: 10px;line-height: 26px;color: rgba(255, 255, 255, 0.8);white-space: pre-wrap">Industriepark Nr. 6 Xinhe, Bezirk Qixia, Stadt Nanjing</li>\n' +
                        '                    <li style="width: 100%;font-size: 16px;margin-top: 10px;line-height: 26px;color: rgba(255, 255, 255, 0.8);white-space: pre-wrap">Postleitzahl：210046</li>\n' +

                        '                </ul>\n' +
                        '            </li>\n' +
                        '        </ul>\n' +
                        '    </div>' ,
                    position: new T.LngLat(118.91619,32.15611),
                    offset: new T.Point(-35, 20)
                })
                // 5.创建地图类型控件
                // const ctrl = new T.Control.MapType([{
                //     title: '地图',
                //     icon: 'http://api.tianditu.gov.cn/v4.0/image/map/maptype/vector.png',                     //地图控件上所要显示的图层图标（默认图标大小80x80）
                //     layer: window.TMAP_NORMAL_MAP
                // }]);
                // 6.将控件添加到地图，一个控件实例只能向地图中添加一次。
                // this.tdtMap.addControl(ctrl);
                // 7.创建坐标，通常是调取接口获得经纬度
                const point = new T.LngLat(118.91619,32.15611);
                // 8.创建覆盖使用的图标
                const icon = new T.Icon({
                    iconUrl: '../marker-red.png',
                    iconSize: new T.Point(27, 27),
                    iconAnchor: new T.Point(10, 25)
                });
                // 9. 创建在该坐标上的一个图像标注实例
                const marker = new T.Marker(point, icon);
                this.tdtMap.addOverLay(this.label)
                // 10.将覆盖物添加到地图中，一个覆盖物实例只能向地图中添加一次
                this.tdtMap.addOverLay(marker);

            }


        },
    };
</script>
<style scoped>
    @media screen and (min-width: 768px){



        #container {
            width: 100%;
            height: 800px;
            position: relative;
        }
        .nanjing{
            z-index: 888;
            top: 100px;
            left:100px;
            height:600px;
            background-color:#fff;
            position: absolute;padding: 40px
        }
        .nanjing li{
            height: 25%
        }
        .nanjing li:first-child{
            font-size: 30px;
        }
        .custom-content-marker {
            position: relative;

        }

        .custom-content-marker img {
            width: 100%;
            height: 100%;
        }

        p{
            font: 18px Arial,"HarmonyOS";
            color: #666;
            margin-top: 10px;
        }
        i{
            font-size: 25px;
            color: black;
        }
        >>> .amap-logo{
            display: none !important;

        }
        >>> .amap-copyright{
            display: none !important;

        }
        >>>.tdt-label{
            padding: 0 !important;
            background: unset !important;
            border: none !important;
            -webkit-box-shadow:none !important;
            box-shadow:none !important;
        }
        >>>.tdt-bottom{
            opacity: 0;
        }

    }

    @media screen and (max-width: 768px){

        #container {
            display: none;
            width: 100%;
            height: 400px;
        }
        .nanjing{
            display: none;
            z-index: 1;

            background-color:#fff;

        }
        .nanjing li:first-child{
            font-size: 1.2rem;
        }
        .nanjing li p:first-child{
            float: left;
            padding-right: 20px;
        }
        .custom-content-marker {
            position: relative;

        }

        .custom-content-marker img {
            width: 100%;
            height: 100%;
        }

        p{
            font: 18px Arial,"HarmonyOS";
            color: #666;
            margin-top: 10px;
        }
        i{
            font-size: 25px;
            color: black;
        }
        >>> .amap-logo{
            display: none !important;

        }
        >>> .amap-copyright{
            display: none !important;

        }
    }
</style>
